var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.212 512.212",
    height: 512,
    viewBox: "0 0 512.212 512.212",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m509.978 433.782-19.997-62.936-30.881-45.966 2.4-43.624-49.18-154.73-17.22-14.42 8.13-14.17-19.874-62.517c-7.856-24.695-34.336-38.404-59.027-30.558l-45.757 14.542c-17.749 5.65-30.499 21.267-32.484 39.784-.185 1.726-.07 3.414.304 5.014-.372 1.59-.488 3.268-.308 4.983.326 3.098.979 6.205 1.942 9.245l20.053 63.066 15.02 14.908-5.93 13.682 49.14 154.63 28.79 43.554-.31 46.036 19.858 62.487c6.355 19.98 24.902 32.769 44.831 32.769 4.703 0 9.483-.712 14.197-2.21l45.756-14.542c11.961-3.807 21.727-12.042 27.497-23.187 5.773-11.152 6.856-23.882 3.05-35.84z",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.978 433.782-19.997-62.936-30.881-45.966 2.4-43.624-49.18-154.73-17.22-14.42 8.13-14.17-19.874-62.517c-7.856-24.695-34.336-38.404-59.027-30.558l-22.471 7.142 154.478 488.147 23.096-7.34c11.961-3.807 21.727-12.042 27.497-23.187 5.772-11.153 6.855-23.883 3.049-35.841z",
    fill: "#ae2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.79 414.306c31.13-10 94.97-30.53 135.19-43.46l-28.48-89.59-135.19 43.46z",
    fill: "#ff7b4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.5 281.256-67.562 21.719 28.364 89.63c23.856-7.67 48.462-15.582 67.678-21.759z",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.32 126.526-135.15 43.56-9.09-28.59 135.15-43.56z",
    fill: "#ff7b4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.32 126.526-9.09-28.59-67.312 21.695 9.052 28.603z",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.003.106h-39c-25.957 0-47 21.043-47 47v66l6 15-5.998 15-.005 162 14.004 47-14.004 47 .003 66c0 25.957 21.043 47 47 47h39c25.957 0 47-21.043 47-47l.047-66-16.023-47 16.023-47-.035-162-8.012-15 8.012-15-.012-66c0-25.957-21.042-47-47-47z",
    fill: "#59c36a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.051 305.106-.035-162-8.012-15 8.012-15-.012-66c0-25.957-21.043-47-47-47h-19.479v512h19.478c25.957 0 47-21.043 47-47l.047-66-16.023-47z",
    fill: "#00a66c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 305.106h133.051v94h-133.051z",
    fill: "#97de3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.525 305.106h66.525v94h-66.525z",
    fill: "#59c36a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.005 113.106h133.01v30h-133.01z",
    fill: "#97de3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.525 113.106h66.49v30h-66.49z",
    fill: "#59c36a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.091 47.097-.082 66.009 7.091 15-7.091 15-.009 162 15.1 47-15.1 47 .009 65.991c-.005 25.961 21.039 47.009 47 47.009h41.991c25.957 0 47-21.043 47-47v-66l-16.9-47 16.9-47v-162l-8.9-15 8.9-15v-66c0-25.957-21.043-47-47-47h-41.909c-25.954 0-46.995 21.037-47 46.991z",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269 47.106c0-25.957-21.043-47-47-47h-21v512h21c25.957 0 47-21.043 47-47v-66l-16.9-47 16.9-47v-162l-8.9-15 8.9-15z",
    fill: "#4895ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133 305.106h136v94h-136z",
    fill: "#7ed8f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 305.106h68v94h-68z",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.009 113.106h135.991v30h-135.991z",
    fill: "#7ed8f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 113.106h68v30h-68z",
    fill: "#6aa9ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.023cc4f0.svg";
export { ForwardRef as ReactComponent };